import type { ReactElement } from 'react';

import Loader from '@/components/Loader';

interface Properties {
  error?: Error;
}
export default function LoadingOrError({ error }: Properties): ReactElement {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <h1 className="text-xl" data-testid="LoadingOrError">
        {error ? error.message : <Loader />}
      </h1>
    </div>
  );
}
LoadingOrError.defaultProps = {
  error: undefined,
};
